import { render } from "./SponsorVue.vue?vue&type=template&id=675e6fd2&scoped=true"
const script = {}

import "../assets/css/sponsor.css?vue&type=style&index=0&id=675e6fd2&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675e6fd2"]])

export default __exports__